module.exports = __webpack_public_path__ + "img/visa-signature.ba874ed7.png";